import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type ExportFileField } from '../ExportFileTypes.ts';
import {
  DescriptionWrapper,
  ExportFieldFieldsSelectText,
  FieldSelect,
  MaxSelectableText,
} from './ExportFileFieldSelect.styles.ts';
import { useExportFileFieldSelectOptions } from './useExportFileFieldSelectOptions.ts';

interface ExportFileFieldSelectProps {
  fields: ExportFileField[] | null | undefined;
  isLoading: boolean;
  selected: string[];
  onSelect: (fields: string[]) => void;
  maxSelectable?: number;
  requireFields?: boolean;
}

export function ExportFieldFieldsSelect(props: ExportFileFieldSelectProps) {
  const {
    fields,
    isLoading,
    onSelect,
    selected,
    maxSelectable,
    requireFields,
  } = props;

  const { t } = useTranslation();
  const options = useExportFileFieldSelectOptions(fields);

  return (
    <>
      <DescriptionWrapper>
        <ExportFieldFieldsSelectText strong>
          {t(
            'export-field-select.select-fields-to-export-title.line-a',
            'Seleziona i campi da esportare.',
          )}
        </ExportFieldFieldsSelectText>
        {requireFields && selected.length === 0 ? (
          <Alert
            type="warning"
            showIcon
            message={t(
              'export-field-select.require-fields-warning',
              'Seleziona almeno un campo per esportare.',
            )}
          />
        ) : (
          !requireFields && (
            <ExportFieldFieldsSelectText>
              <Space size={4}>
                <InfoCircleOutlined aria-hidden="true" />
                {t(
                  'export-field-select.select-fields-to-export-title.line-b',
                  "Se non indichi nessun campo, l'esportazione conterrà tutti i dati.",
                )}
              </Space>
            </ExportFieldFieldsSelectText>
          )
        )}
      </DescriptionWrapper>
      <FieldSelect
        mode={'multiple'}
        placeholder={t(
          'export-field-select.select-fields-to-export',
          'Seleziona i campi da esportare',
        )}
        loading={isLoading}
        options={options}
        onChange={onSelect}
        defaultValue={selected}
        value={selected}
        optionFilterProp={'label'}
        maxCount={maxSelectable}
      />
      {maxSelectable != null && (
        <MaxSelectableText>
          <Space size={4}>
            <InfoCircleOutlined aria-hidden="true" />
            {t(
              'export-field-select.max-selectable-fields',
              'Puoi selezionare al massimo {{max}} campi.',
              { max: maxSelectable },
            )}
          </Space>
        </MaxSelectableText>
      )}
    </>
  );
}
